import styled from 'styled-components'

const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  background: #5352ed;
`

const Content = styled.div`
  position: absolute;
  height: 100%;
  width: calc(100% - 40px);
  top: 0;
  right: 0;
`

const Header = styled.div`
  height: 30px;
  width: calc(100% - 15px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px 0 0;
`

const Details = styled.div`
  height: 65px;
  width: 100%;
`

const ScoreResult = styled.div`
  font-family: ${p => p.theme.fonts.tertiary};
  font-size: 1rem;
  font-weight: 600;
`

const CreatedAt = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  opacity: 0.6;
`

const Company = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: 0.6;
`

const Sale = styled.div`
  height: 45px;
  display: flex;
  font-weight: 600;
  justify-content: flex-start;
  align-items: center;
  font-size: 0.8rem;

  span {
    font-size: 0.6rem;
    font-weight: 700;
    opacity: 0.5;
    margin-bottom: 5px;
  }
`

const Amount = styled.div`
  padding-right: 30px;
  display: flex;
  flex-direction: column;
  color: #329b01;

  span {
    color: ${p => p.theme.colors.dark};
  }
`

const ExpiredAt = styled.div`
  display: flex;
  flex-direction: column;
`

const Empty = styled.div`
  font-family: ${p => p.theme.fonts.secondary};
  text-align: center;
  color: ${p => p.theme.colors.dark};
  padding-top: 10px;
`

export {
  Wrapper,
  Content,
  Header,
  Details,
  ScoreResult,
  CreatedAt,
  Company,
  Sale,
  Amount,
  ExpiredAt,
  Empty,
}
